if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.targetId);
        this.button = this.querySelector('.sticky-atc__button');

        if (!this.target || !this.button) return;

        this.syncButtonState = this.syncButtonState.bind(this);
        this.syncButtonState();

        this.mutationObserver = new MutationObserver(this.syncButtonState);
        this.mutationObserver.observe(this.target, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const isTargetVisible = entries[entries.length - 1].isIntersecting;
            this.classList.toggle('sticky-atc--visible', !isTargetVisible);
          },
          { threshold: 0 }
        );
        this.intersectionObserver.observe(this.target);
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      syncButtonState() {
        this.button.disabled = this.target.disabled;
        this.button.classList.toggle('loading', this.target.classList.contains('loading'));

        const ariaDisabled = this.target.getAttribute('aria-disabled');
        if (ariaDisabled === null) {
          this.button.removeAttribute('aria-disabled');
        } else {
          this.button.setAttribute('aria-disabled', ariaDisabled);
        }

        const targetLabel = this.target.querySelector('span');
        const ownLabel = this.button.querySelector('span');
        if (targetLabel && ownLabel) {
          ownLabel.textContent = targetLabel.textContent;
        }
      }
    }
  );
}
